const detectSideToScroll = (element) => {
  const { height: elementHeight } = element.getBoundingClientRect();
  const liveDocument = element.ownerDocument;
  const windowHeight = (liveDocument.defaultView && liveDocument.defaultView.innerHeight) || 0;
  const isHigherThanViewport = elementHeight > windowHeight;
  return isHigherThanViewport ? 'top' : 'center';
};

export default detectSideToScroll;
